import { FC, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { selectCompanyData } from 'ducks/company'
import { MainLayout } from 'views/layouts'
import TitleDiv from 'views/components/UI/TitleDiv'
import QuestionaryForm from 'views/components/Forms/cuestionary'
import { useNotification } from 'lib/context/notification.context'
import { superAdminRoutes } from 'router/routes'

const QUESTIONNAIRE_ADMIN_ROLES = new Set([
  'special_admin',
  'super_admin',
  'platform_admin',
  'super_platform_admin',
])

const NewQuestionary: FC = () => {
  const navigate = useNavigate()
  const { getWarning } = useNotification()
  const role = useSelector((state: any) => state.auth.role)
  const companyData = useSelector(selectCompanyData)
  const canManageQuestionnaires = QUESTIONNAIRE_ADMIN_ROLES.has(role)
  const canCreateQuestionnaire =
    canManageQuestionnaires &&
    (role === 'super_admin' ||
      companyData?.hasQuestionnaireManagement === true)

  useEffect(() => {
    if (!canCreateQuestionnaire) {
      getWarning('Comunícate con el administrador.')
      navigate(superAdminRoutes.Cuestionario)
    }
  }, [canCreateQuestionnaire, getWarning, navigate])

  if (!canCreateQuestionnaire) return null

  return (
    <MainLayout>
      <TitleDiv>
        <h2 style={{ fontSize: 32 }}>Nuevo cuestionario</h2>
      </TitleDiv>
      <QuestionaryForm />
    </MainLayout>
  )
}

export default NewQuestionary
